<script setup>
import { computed } from "vue";
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
import logo from "@/assets/img/allo-powered.png";
import logoWhite from "@/assets/img/allo-powered-white.png";

const body = document.getElementsByTagName("body")[0];

const darkMode = computed(() => store.state.darkMode);

const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});
</script>
<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-center">
                  <!-- Logo -->
                  <div class="text-center mb-4">
                    <img :src="darkMode || sidebarType === 'bg-default' ? logoWhite : logo" class="img-fluid" alt="Logo"
                      style="max-height: 110px;">
                  </div>
                  <h4 class="font-weight-bolder">¡Lo sentimos! :(</h4>
                  <p class="mb-0">No es posible acceder a esta página.</p>
                </div>
                <div class="card-body">
                    <div class="text-center">
                        <!-- Logo
                      <router-link class="btn btn-warning" to="/signin">
                        Iniciar Sesión
                      </router-link> -->
                    </div>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    <router-link class="btn btn-warning" to="/home">
                        Volver a Inicio
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{
                  backgroundImage: `url(${require('@/assets/img/robot.png')})`,
                  backgroundSize: 'cover'
                }">
                <span class="mask bg-gradient-warning opacity-6"></span>
                <h1 class="mt-5 text-white font-weight-bolder position-relative">
                  CREATING VALUE
                </h1>
                <h4 class="text-white position-relative">
                  THROUGH TECHNOLOGY.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>